<div class="page-title animatedBackground">
    <div class="container">
        <h3>{{ blog.title }}</h3>
        <ul>
            <li><a routerLink="/">Home</a></li>
            <li class="dot-divider"></li>
            <li>Blog</li>
            <li class="dot-divider"></li>
            <li>{{ blog.title }}</li>
        </ul>
    </div>
    <div class="bg-pattern"><img src="assets/img/bg-pattern-2.png" alt="pattern"></div>
</div>

<section class="blog-details-area ptb-100">
    <div class="container">
        <div class="row">
            <div class="col-lg-8 col-md-12">
                <div class="blog-details">
                    <div class="thumb">
                        <img src="http://admin.osit.com.sa/uploads/blogimages/{{ blog.image }}"  alt="details">
                        <div class="date">
                            <span>{{blog.created_at | date: 'dd MMMM yyyy'}}</span>
                        </div>
                    </div>
                    <div class="blog-details-heading">
                        <h3> {{ blog.title }}</h3>
                        <ul>
                            <li>Posted By: <a href="#">{{ blog.createdByName }}</a></li>
                        </ul>
                    </div>
                    <div class="blog-details-content" [innerHtml]="content">
                       
                    </div>
                    <div class="blog-details-meta">
                        <div class="tags">
                           
                        </div>
                        <div class="share">
                            <ul>
                                <li class="title">Share:</li>
                                <li><a href="https://www.facebook.com/sharer/sharer.php?u=https://www.osit.com.sa{{ url }}"><i class="icofont-facebook"></i></a></li>
                                <li><a href="http://www.twitter.com/share?url=https://www.osit.com.sa{{ url }}"><i class="icofont-twitter"></i></a></li>
                                <li><a href="https://www.linkedin.com/sharing/share-offsite/?url=https://www.osit.com.sa{{ url }}"><i class="icofont-linkedin"></i></a></li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>

            <div class="col-lg-4 col-md-12">
                <div class="side-bar mb-0">
                    
                    <div class="widget-box categories-box">
                        <h3 class="title">Categories</h3>
                        <ul >
                            <li *ngFor="let ee of cats;"><a href="blogsbycategory/{{ ee.id }}"><i class="icofont-dotted-right"></i> {{ ee.title }} ({{ ee.blogs }})</a></li>
                        </ul>
                    </div>

                    <div class="widget-box recent-post-box mb-0">
                        <h3 class="title">Recent Post</h3>
                        <ul >
                            <li *ngFor="let lblog of latestblogs;">
                                <div class="recent-post-thumb">
                                    <a href="blog-details/{{ lblog.blog.id }}"><img src="http://admin.osit.com.sa/uploads/blogimages/{{ lblog.blog.image }}" alt="pic"></a>
                                </div>
                                <div class="recent-post-desc">
                                    <h3><a href="blog-details/{{ lblog.blog.id }}">{{ lblog.blog.title }}</a></h3>
                                    <span class="date">{{lblog.blog.created_at | date: 'dd MMMM yyyy'}}</span>
                                </div>
                            </li>
                            
                        </ul>
                    </div>
                    
                </div>
            </div>
        </div>
    </div>
</section>

